import { render, staticRenderFns } from "./DetailCourse.vue?vue&type=template&id=bd98408c"
import script from "./DetailCourse.js?vue&type=script&lang=js&external"
export * from "./DetailCourse.js?vue&type=script&lang=js&external"
import style0 from "./DetailCourse.vue?vue&type=style&index=0&id=bd98408c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports